<footer>  
  <div class="copyright py-4 bg-footer">
    <div class="container">
      <div class="row">
        <div class="col-sm-7 text-sm-left text-center">
          <p class="mb-0">Copyright © 2020 BIP Newsletter, hugo theme by <a href="https://themefisher.com">themefisher</a></p>
        </div>
        <div class="col-sm-5 text-sm-right text-center">
          <ul class="list-inline">
          </ul>
        </div>
      </div>
    </div>
  </div>
</footer>
